module.exports = __webpack_public_path__ + "static/media/ic_check.0c6a6bf7.svg";